import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "bf-accordion-entry__content" }
const _hoisted_2 = { class: "mt-0 d-flex justify-content-between" }
const _hoisted_3 = {
  class: "text-nowrap overflow-hidden",
  style: {"text-overflow":"ellipsis","min-width":"0","margin-right":"0.5rem"}
}
const _hoisted_4 = ["title"]
const _hoisted_5 = { style: {"font-weight":"normal"} }
const _hoisted_6 = { style: {"margin-left":"0.75rem"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cog" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"normal"} }, "Vom Kurs abmelden", -1)
const _hoisted_10 = {
  key: 1,
  class: "bf-course-enrollment-infotext"
}
const _hoisted_11 = { class: "bf-course-enrollment-name" }
const _hoisted_12 = { class: "pe-2" }
const _hoisted_13 = { class: "text-nowrap" }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-envelope" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-phone" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 2,
  class: "bf-course-enrollment-gathering"
}
const _hoisted_21 = { class: "pe-2" }
const _hoisted_22 = { class: "text-nowrap" }
const _hoisted_23 = ["href"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-map-marked" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = ["href"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-directions" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["aria-label"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("b", null, "Kursbeschreibung", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = {
  key: 3,
  class: "bf-course-enrollment-bringalong"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Nächste Termine:")
], -1)
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode("alle Termine anzeigen ")
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", null, "Keine bevorstehenden Kurstermine.", -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "mt-3" }
const _hoisted_43 = { key: 5 }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Kurszeitraum: ")
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" bis ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popper = _resolveComponent("Popper")!
  const _component_CourseEnrollmentModal = _resolveComponent("CourseEnrollmentModal")!
  const _component_UserCourseUpcomingAppointment = _resolveComponent("UserCourseUpcomingAppointment")!
  const _component_CourseActions = _resolveComponent("CourseActions")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bf-accordion-entry", {'bf-accordion-entry--success': _ctx.isWaitingButCanEnroll}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_Popper, {
            hover: true,
            arrow: true
          }, {
            content: _withCtx(() => [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.course.mode === 0 ? 'Offener Kurs' : 'Geschlossener Kurs'), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: "bf-course-type-circle bf-course-type-circle--inline",
                style: _normalizeStyle('background-color:#' + _ctx.course.color),
                title: _ctx.course.mode === 0 ? 'Offener Kurs' : 'Geschlossener Kurs'
              }, null, 12, _hoisted_4)
            ]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.course.course_type.name), 1)
        ]),
        (!_ctx.isContext('archive'))
          ? (_openBlock(), _createBlock(_component_Popper, {
              key: 0,
              hover: true,
              arrow: true,
              class: "bf-course-settings-link"
            }, {
              content: _withCtx(() => [
                _hoisted_9
              ]),
              default: _withCtx(() => [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.withdrawalModalShown = true), ["prevent"])),
                  style: {"font-size":"20px"}
                }, _hoisted_8)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.isContext('archive'))
        ? (_openBlock(), _createBlock(_component_CourseEnrollmentModal, {
            key: 0,
            course: _ctx.course,
            "course-enrollment": _ctx.courseEnrollment,
            shown: _ctx.withdrawalModalShown,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.withdrawalModalShown = false)),
            onEnrollmentStatusChange: _ctx.onEnrollmentStatusChange
          }, null, 8, ["course", "course-enrollment", "shown", "onEnrollmentStatusChange"]))
        : _createCommentVNode("", true),
      (_ctx.course.info_text)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.course.info_text), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.course.region.name) + _toDisplayString(_ctx.course.location?.name && _ctx.course.location?.name !== _ctx.course.region.name ? ` · ${_ctx.course.location?.name}` : '') + " · " + _toDisplayString(_ctx.course.trainer.full_name), 1),
        _createElementVNode("span", _hoisted_13, [
          _createVNode(_component_Popper, {
            hover: true,
            arrow: true,
            offsetDistance: "6",
            content: `Kontaktformular / E-Mail an ${_ctx.course.trainer.prename} schreiben`
          }, {
            default: _withCtx(() => [
              (_ctx.course.trainer.email)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: 'mailto:' + _ctx.course.trainer.email,
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onContactMailClicked && _ctx.onContactMailClicked(...args)), ["prevent"])),
                    class: "pe-2"
                  }, _hoisted_16, 8, _hoisted_14))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["content"]),
          _createVNode(_component_Popper, {
            hover: true,
            arrow: true,
            offsetDistance: "6",
            content: `${_ctx.course.trainer.prename} anrufen`
          }, {
            default: _withCtx(() => [
              (_ctx.course.trainer.phone_mobile)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: 'tel:' + _ctx.course.trainer.phone_mobile
                  }, _hoisted_19, 8, _hoisted_17))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["content"])
        ])
      ]),
      (_ctx.course.gathering_name && !_ctx.isContext('archive'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("span", _hoisted_21, "Treffpunkt: " + _toDisplayString(_ctx.course.gathering_name), 1),
            _createElementVNode("span", _hoisted_22, [
              _createVNode(_component_Popper, {
                hover: true,
                arrow: true,
                offsetDistance: "6",
                content: "Google Maps öffnen"
              }, {
                default: _withCtx(() => [
                  (_ctx.gatheringUrlMap)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _ctx.gatheringUrlMap,
                        target: "_blank",
                        class: "pe-2"
                      }, _hoisted_25, 8, _hoisted_23))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_Popper, {
                hover: true,
                arrow: true,
                offsetDistance: "6",
                content: "Navigation mit Google Maps"
              }, {
                default: _withCtx(() => [
                  (_ctx.gatheringUrlDirections)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _ctx.gatheringUrlDirections,
                        target: "_blank",
                        class: "pe-2"
                      }, _hoisted_28, 8, _hoisted_26))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_Popper, {
                hover: true,
                arrow: true,
                offsetDistance: "6"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _hoisted_30,
                    _hoisted_31,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.descriptionLines, (line) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: line }, [
                        _createElementVNode("span", null, _toDisplayString(line), 1),
                        _hoisted_32
                      ], 64))
                    }), 128))
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("i", {
                    class: "fa fa-info-circle",
                    "aria-label": 'Kursbeschreibung: ' + _ctx.description
                  }, null, 8, _hoisted_29)
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.course.info_bringalong)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createElementVNode("i", null, _toDisplayString(_ctx.course.info_bringalong), 1)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isContext('archive'))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
            (!_ctx.courseEnrollment.waiting)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_34,
                  (_ctx.course?.appointments_upcoming?.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course?.appointments_upcoming, (appointment) => {
                          return (_openBlock(), _createBlock(_component_UserCourseUpcomingAppointment, {
                            key: appointment.id,
                            appointment: appointment,
                            "appointment-enrollment-states": _ctx.appointmentEnrollmentStates
                          }, null, 8, ["appointment", "appointment-enrollment-states"]))
                        }), 128)),
                        (_ctx.showMoreButton)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _createElementVNode("a", {
                                href: "#",
                                onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.loadMoreAppointments && _ctx.loadMoreAppointments(...args)), ["prevent"]))
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["fas fa-fw me-1", {'fa-spin fa-spinner': _ctx.loadingMore, 'fa-angle-down': !_ctx.loadingMore}])
                                }, null, 2),
                                _hoisted_37
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.course /*&& !course?.participants_limit_reached*/)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.course?.participants_limit_reached ? 'Du befindet dich auf der Warteliste.' : 'Es ist ein Platz frei geworden!'), 1)
                        ]),
                        _createVNode(_component_CourseActions, {
                          course: _ctx.course,
                          "user-course-enrollments": [_ctx.courseEnrollment],
                          onEnrollmentStatusChange: _ctx.onEnrollmentStatusChange
                        }, null, 8, ["course", "user-course-enrollments", "onEnrollmentStatusChange"])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
          ], 64))
        : (_ctx.course.appointment_first?.start && _ctx.course.appointment_last?.start)
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
              _hoisted_44,
              _createElementVNode("i", null, _toDisplayString(_ctx.formatDate(_ctx.course.appointment_first.start)), 1),
              _hoisted_45,
              _createElementVNode("i", null, _toDisplayString(_ctx.formatDate(_ctx.course.appointment_last.start)), 1)
            ]))
          : _createCommentVNode("", true)
    ])
  ], 2))
}